import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Divider } from "@mui/material";
import { CONTROL_MARGIN } from "../../MuiThemes";
import { StringCustomControlProps } from "../../Utils/Interfaces";
import { Maybe } from "../../sharedCode/avroGraphql";
import { propertyHasErrors } from "./inputHelpers";

// TODO need some server side work to better support this - should we add landingLocations config or just change getAirportByCode to take an array of airport codes?
// hardcoding the list from demo 3 until the GQL side is ready
//	• Type in landing location PG, fort Nelson, Terrace, fort st john, quessnel, dropdown

// using distinct text for the dividers avoids adding a key
const landingLocations = [
    "CHETWYND - CYCQ",
    "FORT NELSON - CYYE",
    "FORT ST. JOHN - CYXJ",
    "PRINCE GEORGE - CYXS",
    "QUESNEL - CYQZ",
    "TERRACE - CYXT",
    "-",
    "108 MILE - CZML",
    "DAWSON CREEK - CYDQ",
    "KAMLOOPS - CYKA",
    "KELOWNA - CYLW",
    "SMITHERS - CYYD",
    "WILLIAMS LAKE - CYWL",
    "--",
    "EDSON - CYET",
    "GRANDE PRAIRIE - CYQU",
    "HIGH LEVEL - CYOJ",
    "PEACE RIVER - CYPE",
    "RAINBOW LAKE - CYOP",
    "SLAVE LAKE - CYZH",
];

// TODO ROUTING - I get an eslint error when fubar is renamed to props... type checking fails, very strange
export default function LandingLocationEditor(fubar: StringCustomControlProps): JSX.Element {
    const [localValue, setLocalValue] = useState<Maybe<string>>(fubar.initialValue ?? "");

    return (
        <Autocomplete
            disabled={fubar.isDisabled}
            freeSolo
            options={landingLocations}
            value={localValue ?? ""}
            inputValue={localValue ?? ""}
            onInputChange={(e, value) => {
                handleOnChange(value);
            }}
            onBlur={handleOnBlur}
            renderInput={(params) => (
                <TextField
                    {...params}
                    error={propertyHasErrors(fubar.errors, fubar.containerUrl, fubar.sourceId, fubar.sourceProperty)}
                    required={true}
                    margin={CONTROL_MARGIN}
                    label={fubar.labelText}
                />
            )}
            renderOption={(props, option) => handleRenderOption(props, option)}
        />
    );

    function handleRenderOption(props: React.HTMLAttributes<HTMLLIElement>, option: string): JSX.Element {
        if (option.startsWith("-")) {
            return <Divider key={option} variant={"middle"} sx={{ marginTop: 1, marginBottom: 1 }} />;
        }
        return <li {...props}>{option}</li>;
    }

    function handleOnChange(value: string | null): void {
        setLocalValue(value ?? "");
    }

    function handleOnBlur(): void {
        if (localValue !== fubar.initialValue) {
            fubar.mergeChanges(fubar.sourceId, { [fubar.sourceProperty]: localValue?.toLocaleUpperCase() });
        }
    }
}
